export default "__VITE_PUBLIC_ASSET__e78694fb__"